export default {
  userSubscriptionDetails: null,
};
